"use client";
import React from 'react';
import '@sravni/ab-testing-sdk/lib/browser';
import { AbTestingContext } from '../providers/AbTestingProvider/Context.js';

function useAbTestingSdk() {
    return React.useContext(AbTestingContext);
}

export { useAbTestingSdk };
//# sourceMappingURL=useAbTestingSdk.js.map
